import * as AT from '../actions/_types'

export default (prevState = {
  appointmentTypes: [],
  apptTypeFetching: false,
}, action) => {
  switch (action.type) {
    case AT.APPT_TYPES_LIST: {
      return {
        ...prevState,
        appointmentTypes: action.appointmentTypes,
      }
    }
    case AT.APPT_TYPES_FETCHING: {
      return {
        ...prevState,
        apptTypeFetching: true,
      }
    }
    case AT.APPT_TYPES_FETCHED: {
      return {
        ...prevState,
        apptTypeFetching: false,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/appointment-types.js